import {BaseVueEntity} from "@/entities/BaseVueEntity";

export class Image extends BaseVueEntity {


  private readonly _name: string;
  private readonly _version?: string;
  private readonly _text?: string;
  private readonly _path: string;


  constructor(path: string, name: string, version?: string, text?: string) {
    super();

    this._name = name;
    this._version = version;
    this._path = path;
    this._text = text;


  }

  public getUrl(): string {
    return process.env.VUE_APP_BACKEND_URL + '/' + this._path + this._name;
  }

  public getFullImageUrl(): string {
    return `https://assets.eyeled-services.de/pics/${process.env.VUE_APP_PROJECT}/products/` + this._name;
  }

  get name(): string {
    return this._name;
  }

  get version(): string {
    return this._version;
  }

  get text(): string {
    return this._text;
  }

  get path(): string {
    return this._path;
  }
}
